var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSqur(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "534.000000pt",
    height: "456.000000pt",
    viewBox: "0 0 534.000000 456.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\n        Created by potrace 1.16, written by Peter Selinger 2001-2019\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,456.000000) scale(0.100000,-0.100000)",
    fill: "#eef3fe",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1610 4553 c-381 -36 -643 -116 -863 -265 -80 -53 -232 -206 -286 -285 -52 -78 -120 -212 -161 -318 -116 -301 -226 -924 -281 -1585 -6 -74 -13 -398 -16 -721 -4 -509 -3 -600 11 -697 51 -349 196 -536 486 -631 105 -34 250 -51 437 -51 155 0 3275 120 3518 136 128 8 311 38 395 65 165 54 303 161 368 286 94 178 128 537 119 1237 -6 499 -31 794 -103 1236 -82 500 -175 820 -300 1029 -141 238 -305 375 -544 455 -126 42 -234 62 -412 76 -266 21 -2214 48 -2368 33z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqur);
export default __webpack_public_path__ + "static/media/squr.2f38e7f10ce30c237c1f61b0be8ac1c8.svg";
export { ForwardRef as ReactComponent };